// extracted by mini-css-extract-plugin
module.exports = {"title":"SearchByTarget_title__LkAN2","targets":"SearchByTarget_targets__sRfLh","target":"SearchByTarget_target__2Jshy","viewMore":"SearchByTarget_viewMore__rSkl_"};